import React from 'react';

const IconPlus = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9 8V0H8V8H0V9H8V17H9V9H17V8H9Z" fill="currentColor" />
  </svg>

);

export default IconPlus;
